export type AccessTier = 'anonymous' | 'authenticated_18plus' //| 'authenticated'

export class AccessDeniedError extends Error {
  readonly requiredTier: AccessTier
  readonly action: 'prompt_login' | 'prompt_age_gate'

  constructor(requiredTier: AccessTier, action: 'prompt_login' | 'prompt_age_gate') {
    super(`[RUN] Access denied. Required tier: ${requiredTier}. Action: ${action}`)
    this.name = 'AccessDeniedError'
    this.requiredTier = requiredTier
    this.action = action
  }
}
